// Pinned to the v8 (namespaced) SDK: this project's build toolchain
// (react-scripts 3.4.0 / webpack 4) can't parse the optional chaining used
// in the modern v9+ modular build's node_modules output.
import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/messaging";

// Web config values aren't secret (they identify the project, not
// authenticate against it) — same values as firebase-messaging-sw.js below.
const firebaseConfig = {
  apiKey: "AIzaSyD8FSz5QXTdD6bFi5Q3Q_hLhGNDqr6yujc",
  authDomain: "garagi-589ad.firebaseapp.com",
  projectId: "garagi-589ad",
  storageBucket: "garagi-589ad.firebasestorage.app",
  messagingSenderId: "49208021121",
  appId: "1:49208021121:web:7f8103c8d076062ebb7d80",
  measurementId: "G-8J60Y400BY",
};

firebase.initializeApp(firebaseConfig);

try {
  firebase.analytics();
} catch (err) {
  console.warn("Firebase analytics not available in this environment", err);
}

/**
 * Registers the background service worker, asks for notification
 * permission, and returns an FCM token to send to the backend — or null if
 * the browser can't do web push, the user declined, or the VAPID key isn't
 * configured yet (REACT_APP_FIREBASE_VAPID_KEY).
 */
export async function requestPushToken() {
  const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
  if (!vapidKey) {
    console.warn("Firebase: REACT_APP_FIREBASE_VAPID_KEY is not set — skipping web push.");
    return null;
  }
  if (!firebase.messaging.isSupported()) {
    console.warn("Firebase: this browser does not support web push (messaging.isSupported() is false).");
    return null;
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    console.warn(`Firebase: notification permission was "${permission}" — not requesting a token.`);
    return null;
  }

  await navigator.serviceWorker.register("/firebase-messaging-sw.js");
  // register() resolves once the registration exists, not once it's active —
  // subscribing before then fails with "no active Service Worker".
  const registration = await navigator.serviceWorker.ready;
  const messaging = firebase.messaging();

  try {
    const token = await messaging.getToken({
      vapidKey,
      serviceWorkerRegistration: registration,
    });
    if (!token) {
      console.warn("Firebase: getToken() resolved without a token.");
      return null;
    }
    console.log("Firebase: got a push token", token);
    return token;
  } catch (err) {
    console.error("Firebase: could not get a push token", err);
    return null;
  }
}

/** Fires for a push that arrives while the tab is open and focused. */
export async function onForegroundPush(callback) {
  if (!firebase.messaging.isSupported()) return () => undefined;
  return firebase.messaging().onMessage(callback);
}

export default firebase;
